import styles from "./mortgage-type.module.css"

import React from "react"
import createReactClass from "create-react-class"
import cx from "classnames"
import * as fonts from "shared/fonts"
import * as shared from "activities/components/shared"
import * as inputs from "activities/components/inputs"

const Title = ({children}) => <div className={cx(styles["title"], fonts.getFontClass())}>{children}</div>
const Text = ({children}) => <div className={styles["text"]}>{children}</div>

const Pros = ({children}) => (
  <>
    <Title>Pros:</Title>
    <ul>{children}</ul>
  </>
)

const Cons = ({children}) => (
  <>
    <Title>Cons:</Title>
    <ul>{children}</ul>
  </>
)

const Summary = ({children}) => (
  <div>
    <Title>Best For:</Title>
    <Text>
      <p>{children}</p>
    </Text>
  </div>
)

const MortgagePassage = createReactClass({
  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      const element = document.getElementsByClassName("mortgage-passage")[0]
      element.scrollTop = 0
    }
  },
  render() {
    return (
      <div className={cx(styles["passage"], "mortgage-passage", fonts.getFontClass())} tabIndex={"0"}>
        {this.props.children}
      </div>
    )
  }
})

const Conventional = (selected) => (
  <MortgagePassage selected={selected}>
    <Title>Conventional Mortgage</Title>
    <Text>
      <p>
        No bells, whistles, or fine print here. A conventional mortgage is a standard loan that isn’t backed by the Federal Housing Administration (FHA). It’s the most
        straightforward type of loan that gives you the money you need to buy a house, which is paid back over the life of the loan, usually during 15, 20, or 30 years.
      </p>
      <p>
        Conventional loans usually require you to purchase private mortgage insurance. It’s basically an insurance policy that covers your lender in case you can’t pay the money
        back. That can increase the overall cost of your loan, but conventional loans usually require less borrowing and lower closing costs than other types—even if the interest
        rate is slightly higher.
      </p>
    </Text>
    <div className={styles["pros-cons"]}>
      <Pros>
        <li>Simple, straightforward terms</li>
        <li>Lower closing costs</li>
        <li>Rewards good credit with good rates</li>
      </Pros>
      <Cons>
        <li>Interest rate may be higher than that of other loans</li>
        <li>Requires higher down payment than other loans</li>
        <li>Requires private mortgage insurance</li>
      </Cons>
    </div>
    <Summary>Conventional loans are ideal for borrowers with strong credit, a stable income and employment history, and a down payment of at least 3 percent.</Summary>
  </MortgagePassage>
)

const FixedRate = (selected) => (
  <MortgagePassage selected={selected}>
    <Title>Fixed-Rate (Conventional) Mortgage</Title>
    <Text>
      <p>
        If you’re the type of person who values stability, you’ll probably want a fixed-rate mortgage. It ensures that your mortgage payments will remain the same throughout the
        life of the loan, no matter how market conditions change. You’ll essentially “lock in” whatever interest rate your lender offers when you sign on your loan, and you’ll keep
        that interest rate until your loan is paid in full. If interest rates fall drastically, you may even be able to refinance your mortgage at a lower rate (as long as you’re
        willing to pay loan costs again).
      </p>
      <p>
        While you might end up paying a higher interest rate overall, a fixed-rate mortgage gives you the peace of mind that you’ll always know what you owe each month. Most
        fixed-rate loans last for 15, 20, or 30 years, and they are a low-risk way to build equity and credit over time.
      </p>
    </Text>
    <Pros>
      <li>Stable rate and consistent payment for the life of the loan</li>
      <li>Won’t increase if interest rates rise</li>
      <li>Easy to refinance if you want a lower rate</li>
    </Pros>
    <Cons>
      <li>May be a higher rate than an adjustable-rate loan (which could mean paying more in interest over the life of the loan)</li>
      <li>May need to pay closing costs if you decide to refinance to get a lower rate</li>
    </Cons>
    <Summary>Borrowers who want a stable mortgage payment that remains the same, no matter what.</Summary>
  </MortgagePassage>
)

const AdjustableRate = (selected) => (
  <MortgagePassage selected={selected}>
    <Title>Adjustable-Rate (Conventional) Mortgage</Title>
    <Text>
      <p>
        Interest rates pretty much change daily, and if you're willing to assume some of the risk, an adjustable-rate mortgage could result in lower interest costs. It’s a mortgage
        that is subject to market conditions and the interest rates set by the Federal Reserve. If interest rates fall, you’ll owe less each month. If interest rates rise, so does
        your monthly payment.
      </p>
      <p>
        Most lenders “lock in” your low interest rate for one, three, seven, or even ten years, after which you’ll be subject to market fluctuations. Some lenders even allow you to
        “cap” how high interest rates affect your payment.
      </p>
    </Text>
    <Pros>
      <li>Lower interest rate to start</li>
      <li>Interest rate may be locked in for a specified amount of time</li>
      <li>Interest rates may decrease</li>
      <li>May have some more flexibility than a traditional loan</li>
    </Pros>
    <Cons>
      <li>May be difficult to refinance</li>
      <li>Rates could increase, resulting in an unaffordable payment</li>
      <li>Complicated terms and potential penalties for paying off the loan early</li>
    </Cons>
    <Summary>
      Borrowers who don’t qualify for more traditional loans and who are willing to assume the risk of a fluctuating payment, or homeowners who don’t plan on living in their home
      for more than a couple of years.
    </Summary>
  </MortgagePassage>
)

const GovernmentInsured = (selected) => (
  <MortgagePassage selected={selected}>
    <Title>Government-Insured Mortgage</Title>
    <Text>
      <p>
        If you need a mortgage but your credit score isn’t high enough to qualify for a conventional loan, you might be able to get a government-insured loan. It’s basically where
        the FHA promises to pay back your lender if you default, which reduces some of the risks to your bank. In exchange, they loosen some of the credit requirements so
        individuals with lower scores can qualify. It’s also a good option if you have less cash on hand for a down payment, since you can qualify with as little as 3.5 percent
        down.
      </p>
      <p>
        Government-insured mortgages require a lot of documentation to prove that you can and will pay back the loan. They often have higher costs when compared to traditional
        loans because you’ll have a mandatory insurance premium included (which you’ll pay annually).
      </p>
      <p>
        The government also offers specialty loans for veterans (VA loans) or those living in low-income areas (USDA loans), but you’ll have to meet special requirements to
        qualify.
      </p>
    </Text>
    <Pros>
      <li>Can qualify with a lower credit score (as low as 500)</li>
      <li>Allows for a lower down payment</li>
      <li>Can help borrowers qualify for homeownership even if they don’t qualify for a conventional loan.</li>
    </Pros>
    <Cons>
      <li>May require mandatory mortgage insurance</li>
      <li>Can have higher closing costs</li>
      <li>Requires proof of a steady job and income</li>
    </Cons>
    <Summary>Borrowers with smaller down payments, lower-income borrowers, or individuals with lower credit scores with money saved for a down payment.</Summary>
  </MortgagePassage>
)

const Jumbo = (selected) => {
  const date = new Date()
  return (
    <MortgagePassage selected={selected}>
      <Title>Jumbo Mortgage</Title>
      <Text>
        <p>
          Thinking of spending a pretty penny on an expensive home? You might need a “jumbo” mortgage. It’s what lenders call a mortgage above the government’s “conforming mortgage
          limits,” or the amount the FHA has determined that traditional loans cannot exceed. Because home values vary across the United States, the maximum limit depends heavily
          on where you live. While the {date.getFullYear()} conforming loan limit (CLL) is $806,500, it could be much higher in areas with a high cost of living.
        </p>
        <p>
          If you need a jumbo loan, you’ll have to prove that you assume most of the risk and are a safe bet for your lender, since your jumbo loan won’t be insured by traditional
          policies. Your bank will require extensive documentation to prove that you have enough savings in the bank and a steady income. You’ll also need a high credit score of
          above 700 to get the most competitive rates and a down payment between 10 and 20 percent at least.
        </p>
      </Text>
      <Pros>
        <li>Allows for the purchase of high-end homes</li>
        <li>Takes high-cost-of-living areas into consideration</li>
        <li>Gives you more control in deciding how much home you can afford</li>
      </Pros>
      <Cons>
        <li>Requires high credit score</li>
        <li>Requires higher down payment (10–20 percent)</li>
        <li>May need more documentation of income and cash on hand in a savings account</li>
      </Cons>
      <Summary>Borrowers with high credit scores, good savings, and a large down payment, who require more money for a high-end home.</Summary>
    </MortgagePassage>
  )
}

const interestRateOptions = {
  "government-insured": {
    title: "Government-Insured Mortgage",
    subtitle: "FHA, VA, USDA",
    description: GovernmentInsured
  },
  "adjustable-rate": {
    title: "Adjustable-Rate Mortgage",
    subtitle: "Interest rate adjusts with the market",
    description: AdjustableRate
  },
  "jumbo": {
    title: "Jumbo Mortgage",
    subtitle: "Bigger mortgage, high-end home",
    description: Jumbo
  }
}

const mortgageTypeOptions = {
  "conventional": {
    title: "Conventional Mortgage",
    subtitle: "Traditional and lowest cost",
    description: Conventional
  },
  "fixed-rate": {
    title: "Fixed-Rate Mortgage",
    subtitle: "Stable interest rate",
    description: FixedRate
  }
}

export default shared.ActivityFactory(
  ({getProps, getState, updateState}) => {
    const {selected, pageTab} = getState()
    const {theme} = getProps()

    const options = pageTab === "non-traditional" ? interestRateOptions : pageTab === "traditional" ? mortgageTypeOptions : {}

    const optionKeys = Object.keys(options)

    const updateTab = (page, type) => {
      updateState("pageTab")(page)
      updateState("selected")(type)
    }

    return (
      <div>
        <shared.Content className={styles["content"]}>
          <div className={styles["left-side"]}>
            <inputs.Tabs className={styles["page-tabs"]}>
              <inputs.Tab selected={pageTab === "traditional"} handleClick={() => updateTab("traditional", "conventional")}>
                Traditional
              </inputs.Tab>
              <inputs.Tab selected={pageTab === "non-traditional"} handleClick={() => updateTab("non-traditional", "government-insured")}>
                Non-Traditional
              </inputs.Tab>
            </inputs.Tabs>
            <div className={styles["tabs"]}>
              <div className="sr-only">Use the buttons below to learn more about different mortgage types.</div>
              {optionKeys.map((key) => (
                <shared.Tab onClick={() => updateState("selected")(key)} option={options[key]} selected={selected === key} key={key} theme={theme} />
              ))}
            </div>
            <inputs.Dropdown
              label="Select a mortgage type"
              className={styles["dropdown"]}
              initialValue={optionKeys[selected]}
              options={optionKeys.map((key) => [key, options[key].title])}
              onChange={(value) => updateState("selected")(value)}
            />
          </div>
          {React.createElement(options[selected].description, {selected})}
        </shared.Content>
      </div>
    )
  },
  {
    defaultProps: {
      className: "mortgage-type",
      title: "Which Mortgage Is Right for You?",
      subtitle: "Select a mortgage to learn more about.",
      resettable: false
    },
    stateFilter: (state) => state,
    defaultState: {
      pageTab: "traditional",
      selected: "conventional"
    }
  }
)